export function getAuthHeaders(language) {
  var token = localStorage.getItem("authToken");
  var headers = {
    Accept: "application/json",
    "Accept-Language": language || "en",
    "X-Client-Platform": "web",
  };
  if (token) {
    headers.Authorization = "Bearer " + token;
  }
  return headers;
}
